import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import NCZISetupGeneralInformation, { NCZISetupGeneralInformationData } from './NCZISetupGeneralInformation';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: (data: NCZISetupGeneralInformationData) => void;
}

const NCZISetupGeneralInformationModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onSuccess
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} fullScreen={false}>
			<Modal.Header title='Všeobecné informace' />
			<Modal.Content>
				<NCZISetupGeneralInformation onSuccess={onSuccess} />
			</Modal.Content>
		</Modal>
	);
};

export default NCZISetupGeneralInformationModal;
